function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "goofy"
}, /*#__PURE__*/React.createElement("path", {
  d: "M255.05.95C114.42.95,0,115.36,0,256S114.42,511.05,255.05,511.05,510.11,396.63,510.11,256,395.67.95,255.05.95Z",
  fill: "#ffd764"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255,450.5A127.84,127.84,0,0,1,127.54,332.17H382.59A127.92,127.92,0,0,1,255,450.5Z",
  fill: "#fa645a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.69,192.54a71.67,71.67,0,1,1,71.68,71.65,71.67,71.67,0,0,1-71.68-71.65",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.31,229a24.42,24.42,0,1,1,24.43,24.44A24.41,24.41,0,0,1,145.31,229",
  fill: "#00b4dc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M436.43,192.54a71.67,71.67,0,1,0-71.68,71.65,71.65,71.65,0,0,0,71.68-71.65",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M364.82,229a24.43,24.43,0,1,0-24.46,24.44A24.43,24.43,0,0,0,364.82,229",
  fill: "#00b4dc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.56,309.42A116.68,116.68,0,1,1,235.24,192.75,116.8,116.8,0,0,1,118.56,309.42Zm0-212.89a96.22,96.22,0,1,0,96.21,96.22,96.32,96.32,0,0,0-96.21-96.22Z",
  fill: "#4a4a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.31,309.42A116.68,116.68,0,1,1,512,192.75,116.81,116.81,0,0,1,395.31,309.42Zm0-212.89a96.22,96.22,0,1,0,96.23,96.22,96.32,96.32,0,0,0-96.23-96.22Z",
  fill: "#4a4a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M283.66,187.83H230.82a10.24,10.24,0,0,1,0-20.48h52.83a10.24,10.24,0,0,1,0,20.48Z",
  fill: "#4a4a4a"
}));

function SvgPlaying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "goofy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaying);
export default __webpack_public_path__ + "static/media/playing.61df6a65.svg";
export { ForwardRef as ReactComponent };